import styled from '@emotion/styled'

export const SectionTitle = styled.h2`
	color: ${({ theme }) => theme.bestPicks.sectionTitleColor};
	font-size: 22px;
	text-align: center;
	text-transform: uppercase;

	${({ theme }) => theme.MQ.M} {
		text-align: left;
	}
`
